import { AuthTypes } from 'enums';

export default function providerInfoKnown(userAuth, adobePassInfo, ipInfo) {
    if (userAuth.length === 0 || (userAuth.indexOf(AuthTypes.MVPD) === -1 && userAuth.indexOf(AuthTypes.ISP) === -1)) {
        return true;
    } else if (userAuth.indexOf(AuthTypes.MVPD) !== -1) {
        return !!adobePassInfo;
    } else if (userAuth.indexOf(AuthTypes.ISP) !== -1) {
        return !!ipInfo;
    }
    return false;
};



// WEBPACK FOOTER //
// ./app/lib/auth/providerInfoKnown.js